import { useState } from 'react'

import { useSaveSettings, useSettings } from '../../hooks/queries'
import { useTexte } from '../../texte'
import { fehlertext } from '../../api/client'

/**
 * One POI per place (#96, 1.51.0): the radius within which a halt from a
 * recording, or a new POI set by hand, becomes the spot of an existing POI.
 * Read by the stop detection on the server and by the point's form in the
 * browser; the same number for both, from use: "nicht zu viele Pins in
 * einem Ort."
 *
 * Its own card and not a third field under "Aufenthalte": the stop
 * detection is about what counts as a halt, this is about what becomes a
 * POI at all -- and it applies to the manual ways as well. Typed, kept
 * until the button, "Gespeichert." afterwards, like `ErkennungCard`.
 */
export function PlaceMergeCard() {
  const t = useTexte()
  const settings = useSettings()
  const save = useSaveSettings()
  const [entwurf, setEntwurf] = useState<string | null>(null)
  const [gemeldet, setGemeldet] = useState(false)

  const daten = settings.data
  // Without the ceiling this account is no administration -- the server decided.
  if (!daten?.ceiling || !daten.limits) return null

  const werte = daten.settings
  const grenzen = daten.limits
  const wert = Number(entwurf ?? werte.spot_merge_radius_m)
  const offen = entwurf !== null && Number.isInteger(wert) && wert !== werte.spot_merge_radius_m

  return (
    <div className="card card--seite" data-ein-poi-je-ort="">
      <h2 className="card__titel">{t.einPoiJeOrt.titel}</h2>
      <p className="card__lead">{t.einPoiJeOrt.lead}</p>
      <label className="field field--luft">
        <span className="field__label">{t.einPoiJeOrt.umkreis}</span>
        <input
          className="field__input"
          type="number"
          inputMode="numeric"
          name="spot_merge_radius_m"
          value={entwurf ?? String(werte.spot_merge_radius_m)}
          min={grenzen.spot_merge_radius_m.min}
          max={grenzen.spot_merge_radius_m.max}
          onChange={(e) => setEntwurf(e.target.value)}
        />
        <span className="feld__hinweis">{t.einPoiJeOrt.umkreisHinweis}</span>
      </label>
      {save.isError && (
        <p className="notice" role="alert">{fehlertext(save.error)}</p>
      )}
      {gemeldet && !save.isPending && (
        <p className="card__lead akzent">{t.allgemein.gespeichert}</p>
      )}
      <button
        className="button button--outline"
        type="button"
        disabled={!offen || save.isPending}
        onClick={() => {
          setGemeldet(false)
          save.mutate({ spot_merge_radius_m: wert }, {
            onSuccess: () => {
              setEntwurf(null)
              setGemeldet(true)
            },
          })
        }}
      >
        {save.isPending ? t.allgemein.laeuft : t.allgemein.speichern}
      </button>
    </div>
  )
}
